export enum RewardStatus {
  NO_STARTED = 'NO_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export type RewardType = {
  id: number;
  name: string;
  points: number;
  status: RewardStatus;
};
